/// <amd-module name="Wit/WitFirstRun/WitFirstRunService" />
import * as React from "react";

import { Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { WitFirstRunComponent } from "./Components/WitFirstRunComponent";

import * as Resources from "Wit/WitFirstRun/Resources";

class WitFirstRunService extends VssService {
    public showFirstRunUI(): void {
        const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        
        layoutManager.renderCallout(onDismiss => {
            return React.createElement(WitFirstRunComponent, {
                onDismiss: onDismiss,
                className: "bolt-teaching-panel",
                settingName: "wit/firstRunDismissed",
                slides: [
                    {
                        title: Resources.FirstSlideTitle,
                        description: Resources.FirstSlideDescription,
                        slideImage: getAssetLocation(this.pageContext, "ms.vss-work-web/wit-firstrun-content/Images/Slide_1.png")
                    },
                    {
                        title: Resources.SecondSlideTitle,
                        description: Resources.SecondSlideDescription,
                        slideImage: getAssetLocation(this.pageContext, "ms.vss-work-web/wit-firstrun-content/Images/Slide_2.png")
                    },
                    {
                        title: Resources.ThirdSlideTitle,
                        description: Resources.ThirdSlideDescription,
                        slideImage: getAssetLocation(this.pageContext, "ms.vss-work-web/wit-firstrun-content/Images/Slide_3.png")
                    },
                    {
                        title: Resources.FourthSlideTitle,
                        description: Resources.FourthSlideDescription,
                        slideImage: getAssetLocation(this.pageContext, "ms.vss-work-web/wit-firstrun-content/Images/Slide_4.png")
                    }
                ]
            });
        });
    }

    public nwpShowFirstRunUI(): void {
        const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        
        layoutManager.renderCallout(onDismiss => {
            return React.createElement(WitFirstRunComponent, {
                onDismiss: onDismiss,
                className: "bolt-teaching-panel teaching-panel-nwp",
                settingName: "wit/firstRunDismissedNwp",
                slides: [
                    {
                        title: Resources.NwpFirstSlideTitle,
                        description: Resources.NwpFirstSlideDescription,
                        slideImage: getAssetLocation(this.pageContext, "ms.vss-work-web/wit-firstrun-content/Images/Slide_1.png")
                    },
                    {
                        title: Resources.NwpSecondSlideTitle,
                        description: Resources.NwpSecondSlideDescription,
                        slideImage: getAssetLocation(this.pageContext, "ms.vss-work-web/wit-firstrun-content/Images/Slide_2.png")
                    }
                ]
            });
        });
    }
}

Services.add("WitFirstRunService", { serviceFactory: WitFirstRunService });
